import React from 'react';
import { Box, Typography } from '@mui/material';

const WARN = 80;
const CRITICAL = 90;

// A small chart of one reading (0-100% unless max is given) with dashed lines at the warning and critical levels (none when they are null). Click to enlarge.
export default function Spark({ title, values, timestamps, color, onOpen, max = 100, warn = WARN, critical = CRITICAL, help }) {
  const W = 360;
  const H = 70;
  const points = values.map((v, i) => (v == null ? null : [(i / Math.max(values.length - 1, 1)) * W, H - (Math.min(v, max) / max) * H]));
  const segments = [];
  let run = [];
  points.forEach((p) => { if (p) run.push(p); else if (run.length) { segments.push(run); run = []; } });
  if (run.length) segments.push(run);
  const first = timestamps[0] ? new Date(timestamps[0]).toLocaleString() : '';
  const last = timestamps[timestamps.length - 1] ? new Date(timestamps[timestamps.length - 1]).toLocaleString() : '';
  return (
    <Box component="button" type="button" onClick={onOpen} aria-label={`Enlarge ${title}`} title={help ? `${help} Click to enlarge.` : 'Click to enlarge'}
      sx={{ minWidth: 0, textAlign: 'left', background: 'none', border: 0, p: 0, font: 'inherit', cursor: 'zoom-in', '&:hover svg': { borderColor: 'primary.main' } }}>
      <Typography variant="caption" fontWeight="bold">{title}</Typography>
      <svg viewBox={`0 0 ${W} ${H}`} width="100%" height={H} role="img" aria-label={`${title} over time`} preserveAspectRatio="none" style={{ background: '#fafafa', border: '1px solid #e0e0e0' }}>
        {warn != null && <line x1="0" x2={W} y1={H - (warn / max) * H} y2={H - (warn / max) * H} stroke="#ed6c02" strokeDasharray="3 3" strokeWidth="1" />}
        {critical != null && <line x1="0" x2={W} y1={H - (critical / max) * H} y2={H - (critical / max) * H} stroke="#d32f2f" strokeDasharray="3 3" strokeWidth="1" />}
        {segments.map((seg, i) => (seg.length === 1
          ? <circle key={i} cx={seg[0][0]} cy={seg[0][1]} r="1.5" fill={color} />
          : <polyline key={i} points={seg.map((p) => p.join(',')).join(' ')} fill="none" stroke={color} strokeWidth="1.5" vectorEffect="non-scaling-stroke" />))}
      </svg>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="caption" color="text.secondary">{first}</Typography>
        <Typography variant="caption" color="text.secondary">{last}</Typography>
      </Box>
    </Box>
  );
}
